import { Box, Button, Typography, Link, Stack } from '@mui/material';
import { useCookieConsent } from '@/contexts/CookieConsentContext';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';

const CookieConsentBanner = () => {
  const { hasConsented, acceptAll } = useCookieConsent();

  if (hasConsented) {
    return null;
  }

  return (
    <StyledBanner>
      <Stack spacing={2}>
        <Typography variant="h6" fontWeight={600}>
          <FormattedMessage
            id="cookieConsent.title"
            defaultMessage="We value your privacy"
          />
        </Typography>
        <Typography variant="body2" color="textSecondaryDarkGrey">
          <FormattedMessage
            id="cookieConsent.description"
            defaultMessage='We use cookies to enhance your browsing experience and analyse our traffic. By clicking "Accept All", you consent to our use of cookies.'
          />{' '}
          <FormattedMessage
            id="cookieConsent.privacyPolicyDescription"
            defaultMessage="By continuing to browse our website, you agree to our {privacyPolicy}."
            values={{
              privacyPolicy: (
                <Link
                  component="a"
                  href="/assets/privacy_policy_rubyplay.pdf"
                  download
                >
                  <FormattedMessage
                    id="cookieConsent.privacyPolicy"
                    defaultMessage="Privacy Policy"
                  />
                </Link>
              ),
            }}
          />
        </Typography>
        <Stack direction="row" spacing={2} flexWrap="wrap">
          <Button
            variant="contained"
            onClick={acceptAll}
            sx={{ minWidth: '120px' }}
          >
            <FormattedMessage
              id="cookieConsent.acceptAll"
              defaultMessage="Accept All"
            />
          </Button>
        </Stack>
      </Stack>
    </StyledBanner>
  );
};

const StyledBanner = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: theme.palette.white,
  boxShadow: '0px -4px 12px rgba(0, 0, 0, 0.15)',
  zIndex: 9999,
  padding: theme.spacing(3),
  borderTop: `1px solid ${theme.palette.grey200}`,
}));

export default CookieConsentBanner;
